// extracted by mini-css-extract-plugin
export var quote = "style-module--quote--55c25";
export var quote__block = "style-module--quote__block--595aa";
export var quote__container = "style-module--quote__container--aae0d";
export var quote__name = "style-module--quote__name--2b5c3";
export var quote__text = "style-module--quote__text--e97e4";
export var quote__wrapper = "style-module--quote__wrapper--ddde7";